export default "__VITE_ASSET__Ddy5UdMV__"